import { render, staticRenderFns } from "./AvizVfx.vue?vue&type=template&id=16f5968d&"
import script from "./AvizVfx.vue?vue&type=script&lang=js&"
export * from "./AvizVfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports